import React, { useState } from 'react';
import {
    FormCollectionContainerProps,
    FormCollectionViewProps,
} from './formCollectionProps';
import { ReportingContainerBaseConfig } from '../../../../base';
import {
    FormCollectionController,
    FormCollectionLoader,
    FormCollectionStateProvider,
} from './formCollectionInterface';
import { useSearchParams } from 'react-router-dom';
import { ContentObject, Property, AnyValue } from '@varos/research-sdk-api';
import { ContextItem } from '@varos/assistant-sdk';
import { assertNever } from '@varos/util-typescript';

export function createFormCollectionContainer(
    config: ReportingContainerBaseConfig & {
        keys: {
            recordUrlParam: string;
        }
    },
    // states: FormCollectionStateProvider,
    loader: FormCollectionLoader,
    controller: FormCollectionController,
    View: React.FC<FormCollectionViewProps>
): React.FC<FormCollectionContainerProps> {
    const {
        context: { useContext },
        navigation,
        pubsub,
        repository,
    } = config;
    return ({ ...containerProps }) => {
        const context = {
            root: useContext(),
        };
        // const state = states.useState(context.root, containerProps);
        const [searchParams, setSearchParams] = useSearchParams();
        const data = loader.useLoad(context.root, containerProps);
        const [isAnalyzing, setIsAnalyzing] = useState(false);
        const props = controller.useProps(context.root, data, {
            collection: {
                onNewClick() {
                    navigation.record.new.open({
                        search: [searchParams, setSearchParams],
                        collection: containerProps.collection,
                    });
                },
                isAnalyzing,
                onAnalyzeClick() {
                    const subscription = pubsub.dispatch({
                        kind: 'analyze_selection',
                        data: {
                            selection: {
                                kind: 'form',
                                id: containerProps.form,
                            },
                            start_immediately: true,
                        },
                    });
                    // check if promise returned, if so, set isAnalyzing to true
                    if (subscription instanceof Promise) {
                        subscription.finally(() => {
                            setIsAnalyzing(true);
                        });
                    } else {
                        setIsAnalyzing(true);
                    }
                },
                query: data.collection.record.query,
                record: {
                    onOpen(item) {
                        searchParams.set(config.keys.recordUrlParam, item.id);
                        setSearchParams(searchParams, { replace: true });
                    },
                },
                filter: {
                    visible: {
                        value: false,
                        onChange: () => {},
                    },
                    value: {},
                    onAdd(property: Property, value: AnyValue) {},
                    onRemove(property: Property) {},
                    onClear() {},
                    // visible: {
                    //     value: state.filterVisible.value,
                    //     onChange: state.filterVisible.onChange,
                    // },
                    // value: state.filter.value,
                    // onAdd(property: Property, value: AnyValue) {
                    //     state.filter.onChange({
                    //         ...state.filter.value,
                    //         [property.key]: value,
                    //     });
                    // },
                    // onRemove(property: Property) {
                    //     state.filter.onChange(
                    //         Object.fromEntries(
                    //             Object.entries(state.filter.value).filter(
                    //                 ([key]) => key !== property.key
                    //             )
                    //         )
                    //     );
                    // },
                    // onClear() {
                    //     state.filter.onChange({});
                    // },
                },
            },
        });
        return <View {...props} />;
    };
}
